import React from 'react';
import ContentWrapper from "../../components/Content";
import contents from './contents';

const AccountSecurityPage = props => {
    return (
        <ContentWrapper contents={contents} title='Account Security' />
    )
}

export default AccountSecurityPage;